import React from 'react'
import { FloraVariants, CSS, styled, forwardRef } from '@grupoboticario/flora-react-system'
import { filterUndefined, HTMLFloraProps } from '@grupoboticario/flora-react-utils'

export const StyledFlex = styled('div', {
  boxSizing: 'border-box',
  display: 'flex',
})

export type FlexProps = HTMLFloraProps<'div'> &
  FloraVariants<typeof StyledFlex> & {
    direction?: CSS['flexDirection']
    align?: CSS['alignItems']
    justify?: CSS['justifyContent']
    wrap?: CSS['flexWrap']
    templateColumns?: CSS['gridTemplateColumns']
    templateRows?: CSS['gridTemplateRows']
    gap?: CSS['gap']
    gapX?: CSS['columnGap']
    gapY?: CSS['rowGap']
  }

/**
 * @component
 * @name Flex
 * @description Flex component
 * @tutorial https://flora.gb.tech/docs/components/core/flex
 */
export const Flex = forwardRef<'div', FlexProps>((props, forwardedRef) => {
  const {
    direction,
    align,
    justify,
    wrap,
    templateColumns,
    templateRows,
    gap,
    gapX,
    gapY,
    css,
    ...rest
  } = props

  const flexStyles = filterUndefined({
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap,
    gridTemplateColumns: templateColumns,
    gridTemplateRows: templateRows,
    gap,
    columnGap: gapX,
    rowGap: gapY,
    css,
  } as CSS)

  return <StyledFlex ref={forwardedRef} css={{ ...flexStyles, ...(css as any) }} {...rest} />
})

const StyledSpacer = styled('div', {
  flex: 1,
  justifySelf: 'stretch',
  alignSelf: 'stretch',
})

export type SpacerProps = FlexProps

/**
 * @tutorial https://flora.gb.tech/docs/components/core/flex
 */
export const Spacer = forwardRef<'div', FlexProps>((props, forwardedRef) => {
  return <StyledSpacer ref={forwardedRef} {...props} />
})
